import React, { Component } from "react";
import { useTranslations } from '../../locales/useTranslations';

const ÜberunsEinUnternehmenMitWertenUndMoral = () => {
  const { t } = useTranslations();
  return (
    <section className="about-area ptb-100">
      <div className="container">
        <div className="row align-items-center">
          <div className="row align-items-center">

            <div className="col-lg-12 col-md-12">
              <div className="about-content">
                <span className="sub-title">{t('about_values_subtitle')}</span>
                <h2>{t('about_values_title')}</h2>
                <p dangerouslySetInnerHTML={{ __html: t('about_values_paragraph1') }} />
                <p dangerouslySetInnerHTML={{ __html: t('about_values_paragraph2') }} />
                <p dangerouslySetInnerHTML={{ __html: t('about_values_paragraph3') }} />
                <p dangerouslySetInnerHTML={{ __html: t('about_values_paragraph4') }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ÜberunsEinUnternehmenMitWertenUndMoral;
